module.exports = __webpack_public_path__ + "img/t4.e48897c2.jpg";